<script setup>
import ApikomTaskTimeTable from '@frontJs/components/tables/projectManagement/tasks/ApikomTaskTimeTable.vue';
import ProjectManagementLayout from '@frontJs/layouts/ProjectManagementLayout.vue';
import { Head } from '@inertiajs/vue3';
import TabLayout from '@js/components/tabs/TabLayout.vue';
import PageTitle from '@js/components/titles/PageTitle.vue';
import { useRoute } from '@js/utils/route';
import { h, onMounted, ref } from 'vue';

const { route } = useRoute();

const loading = ref(true);

const validateCount = ref(0);

function updateData() {
    loading.value = true;

    axios
        .get(route('front.projectManagement.task.getTaskTimesToValidateCount'))
        .then((response) => {
            validateCount.value = response.data.count;
        })
        .catch((error) => {
            console.log(error);
        })
        .finally(() => {
            loading.value = false;
        });
}

onMounted(() => {
    updateData();
});

defineOptions({ layout: ProjectManagementLayout });
</script>

<template>
    <Head>
        <title>Temps Apikom - Tâches - Gestion de projet - Datakepler</title>
    </Head>

    <PageTitle> Gestion de projet - Tâches - Temps Apikom </PageTitle>

    <TabLayout
        :tabs="{
            toValidateHourlyPackageAndProject: {
                title: 'À valider (H/F/P)',
                total: validateCount,
                content: h(ApikomTaskTimeTable, {
                    userSessionKey: 'task_times_to_validate',
                    toValidate: true,
                }),
            },
            allHourlyPackageAndProject: {
                title: 'Tous (H/F/P)',
                content: h(ApikomTaskTimeTable, {
                    userSessionKey: 'task_times',
                }),
            },
            hourlyValidatedTime: {
                title: 'Temps (H)',
                content: h(ApikomTaskTimeTable, {
                    userSessionKey: 'task_times_hourly_validated',
                    type: 'hourly',
                    validated: true,
                }),
            },
            packageTime: {
                title: 'Temps (F)',
                content: h(ApikomTaskTimeTable, {
                    userSessionKey: 'task_times_package_validated',
                    type: 'package',
                    validated: true,
                }),
            },
            projectTime: {
                title: 'Temps (P)',
                content: h(ApikomTaskTimeTable, {
                    userSessionKey: 'task_times_project_validated',
                    type: 'project',
                    validated: true,
                }),
            },
        }"
        :loading="loading"
    />
</template>
